import { ApplicationStep } from '../../../../../../types/apiTypes';
import { RequestDocument } from '../../../../../signup/customers/DocumentUpload';

/**
 * Header copy for the onboarding "Submit Bank Statements" path (THT-703). Shared so the dashboard
 * card and the (otherwise generic) document-upload screen show the same voice and can't drift.
 */
export const ONBOARDING_STATEMENTS_UPLOAD_COPY = {
  title: 'Upload Your Bank Statements',
  description:
    'Upload your last 6 months of business bank statements so we can verify your revenue.',
};

/**
 * True when the customer's only open document request is the onboarding revenue-verification one —
 * i.e. they chose "Submit Bank Statements" instead of linking with Plaid. Used to show the
 * bank-statements voice without mislabeling generic admin/compliance requests (which stay generic).
 */
export function isOnboardingStatementsContext(
  applicationStep: string | undefined,
  requestedDocs: RequestDocument[]
): boolean {
  if (applicationStep !== ApplicationStep.ManualDocumentUpload) return false;
  const openRequests = requestedDocs.filter((doc) => !doc.submitted);
  return (
    openRequests.length === 1 &&
    openRequests[0].is_onboarding_revenue_verification === true
  );
}
